"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FileFormatAudio = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FileFormatAudio_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.5 10.75 1.871 1.676c.26.182.629.007.629-.3V4.874c0-.307-.368-.482-.629-.3L5.5 6.25h-.921C3.707 6.25 3 6.92 3 7.75v1.5c0 .829.707 1.5 1.579 1.5H5.5ZM7 6.25l-.833.746a1 1 0 0 1-.667.255h-.921c-.369 0-.579.271-.579.5v1.5c0 .229.21.5.579.5H5.5a1 1 0 0 1 .667.255l.833.746V6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.379 5.12a.5.5 0 1 0-.652.76c1.697 1.457 1.697 3.783 0 5.24a.5.5 0 1 0 .652.76c2.162-1.857 2.162-4.903 0-6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.826 6.454a.5.5 0 1 0-.652.759c.84.72.84 1.853 0 2.574a.5.5 0 0 0 .652.759c1.304-1.12 1.304-2.972 0-4.092Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 3.983 10.916.571A2 2 0 0 0 9.517 0H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5.412a2 2 0 0 0-.6-1.429ZM2 3v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.412a1 1 0 0 0-.3-.714l-3.483-3.412a1 1 0 0 0-.7-.286H4a2 2 0 0 0-2 2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FileFormatAudio_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FileFormatAudio;
exports["default"] = _default;